// src/data/products.ts

import Product1 from "../assets/products/2.png.webp";
import Product2 from "../assets/products/3.png.webp";
import Product3 from "../assets/products/4.png.webp";
import Product4 from "../assets/products/5.png.webp";
import Product5 from "../assets/products/6.png.webp";
import Product6 from "../assets/products/7.png.webp";
import Product7 from "../assets/products/8.png.webp";
import Product8 from "../assets/products/9.png.webp";
import Product9 from "../assets/products/10.png.webp";
import Product10 from "../assets/products/11.png.webp";
import Product11 from "../assets/products/12.png.webp";
import Product12 from "../assets/products/13.png.webp";
import Product13 from "../assets/products/14.png.webp";
import Product14 from "../assets/products/15.png.webp";
import Product15 from "../assets/products/16.png.webp";
import Product16 from "../assets/products/17.png.webp";
import Product17 from "../assets/products/18.png.webp";
import Product18 from "../assets/products/19.png.webp";
import Product19 from "../assets/products/20.png.webp";
import Product20 from "../assets/products/21.png.webp";
import Product21 from "../assets/products/22.png.webp";
import Product22 from "../assets/products/23.png.webp";
import ClosetsSectionImage_5 from "../assets/productSectopnImage/Closets_5.png.webp";
import ClosetsSectionImage_1 from "../assets/productSectopnImage/image1.jpeg.webp";
import ClosetsSectionImage_2 from "../assets/productSectopnImage/image_2.jpeg.webp";
import ClosetsSectionImage_3 from "../assets/productSectopnImage/image3.jpeg.webp";
import ClosetsSectionImage_4 from "../assets/productSectopnImage/image4.jpeg.webp";
import ClosetsSectionImage_6 from "../assets/productSectopnImage/image5.jpeg.webp";
import ClosetsSectionImage_7 from "../assets/productSectopnImage/image6.jpeg.webp";
import ClosetsSectionImage_8 from "../assets/productSectopnImage/image7.jpeg.webp";
import ClosetsSectionImage_9 from "../assets/productSectopnImage/image8.jpeg.webp";
import ClosetsSectionImage_10 from "../assets/productSectopnImage/image9.jpeg.webp";
import ClosetsSectionImage_11 from "../assets/productSectopnImage/image10.jpeg.webp";
import ClosetsSectionImage_12 from "../assets/productSectopnImage/image11.jpeg.webp";
import ClosetsSectionImage_13 from "../assets/productSectopnImage/image12.jpeg.webp";

interface ProductVariant {
  voltage: string;
  power: string;
  lumen: string;
  size: string;
}

export interface Product {
  id: number;
  image: string;
  name: string;
  description: string;
  variants: ProductVariant[];
  cri?: string;
  base?: string;
  lifeHours?: string;
  beamAngle?: string;
  categories: string[];
  /** Optional image for the Closets section on the product detail page. If not set, the product's main image is used. */
  closetsSectionImage?: string;
}

export const products: Product[] = [
  // id 1: Household LED Lamp with 7 variants
  {
    id: 1,
    image: Product1,
    name: "Bixton LED Household Lamp",
    description:
      "Bixton Household LED lamps are energy-saving, eco-friendly replacements for incandescent and CFL bulbs. Available in B22 or E27 bases with Cool Daylight or Warm White options, they save over 80% energy and last up to 20,000 hours. Not suitable for dimming or outdoor use unless protected. ",
    cri: ">80",
    base: "B22/E27",
    lifeHours: "20,000",
    beamAngle: "230°",

    categories: ["Lamps", "Home Lighting"],

    variants: [
      { voltage: "160-260V", power: "3W", lumen: "270", size: "A50" },
      { voltage: "160-260V", power: "4.8W", lumen: "450", size: "A50" },
      { voltage: "160-260V", power: "7W", lumen: "630", size: "A60" },
      { voltage: "160-260V", power: "9W", lumen: "810", size: "A60" },
      { voltage: "160-260V", power: "12W", lumen: "1080", size: "A65" },
      { voltage: "160-260V", power: "15W", lumen: "1350", size: "A65" },
      { voltage: "160-260V", power: "18W", lumen: "1620", size: "A80" },
    ],
  },

  // id 2 to 22: single-variant products
  {
    id: 2,
    image: Product2,
    name: "Bixton High Power LED Lamps",
    description:
      "This lamp is ideal for areas needing high light levels such as workshops, car parks, garages, and large halls. It is a compact replacement for linear lamps, fits standard holders, lasts up to 20,000 hours, and is not recommended for outdoor use unless protected.",
    cri: ">80",
    base: "B22/E27",
    lifeHours: "20,000",
    beamAngle: "230°",
    categories: ["Lamps", "Commercial Lighting"],
    variants: [
      { voltage: "100-300V", power: "28W", lumen: "2100", size: "T100" },
      { voltage: "160-260V", power: "38W", lumen: "2880", size: "T120" },
      { voltage: "160-260V", power: "50W", lumen: "4000", size: "T140" },
    ],
  },
  {
    id: 3,
    image: Product3,
    name: "Bixton Panel Lights",
    description:
      "This sturdy, elegant light fitting is suitable for ceilings or soffits, providing even, glare-free light. It offers  flicker-free, silent operation, saves over 80% energy, and is ideal for offices, shops, showrooms, and study areas for long-lasting, cost-efficient lighting.",
    cri: ">80",
    lifeHours: "25,000",
    beamAngle: "120°",
    categories: ["Home Lighting", "Commercial Lighting"],
    variants: [
      {
        voltage: "160-265V",
        power: "6W",
        lumen: "390",
        size: "11.7 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "12W",
        lumen: "780",
        size: "16.7 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "18W",
        lumen: "1170",
        size: "22.2 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "24W",
        lumen: "1560",
        size: "27.0 x 3.5",
      },
    ],
  },
  {
    id: 4,
    image: Product4,
    name: "Bixton Pro Panel Lights",
    description:
      "This elegant back-lit light fitting with an integrated driver is made of high-quality plastic and suits coastal installations. Available in surface or recessed, round or square designs, it offers flicker-free, silent lighting, saves over 80% energy, and is ideal for offices, shops, showrooms, and study areas. Available in Cool Daylight and Warm White",
    cri: ">80",
    lifeHours: "25,000",
    beamAngle: "120°",
    categories: ["Home Lighting", "Commercial Lighting"],
    variants: [
      {
        voltage: "160-265V",
        power: "6W",
        lumen: "600",
        size: "11.7 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "12W",
        lumen: "1200",
        size: "16.7 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "18W",
        lumen: "1800",
        size: "22.2 x 3.5",
      },
      {
        voltage: "160-265V",
        power: "24W",
        lumen: "2400",
        size: "27.0 x 3.5",
      },
    ],
  },
  {
    id: 5,
    image: Product5,
    name: "Bixton Ultra Panel Lights",
    description:
      "Lighting up spaces with enhanced aesthetics ensuring a higher intensity of light on the surface. This back lit panel light fitting is designed especially for interiors which requires aesthetics to blend with a modern environment. It can be mounted on any ceiling or concrete soffit with both black & white metal housing.",
    cri: ">80",
    lifeHours: "20,000 - 25,000",
    beamAngle: "90° - 120°",
    categories: ["Home Lighting"],
    closetsSectionImage: ClosetsSectionImage_5,
    variants: [
      {
        voltage: "85-265V",
        power: "16W",
        lumen: "1920",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "22W",
        lumen: "2640",
        size: "",
      },
    ],
  },
  {
    id: 6,
    image: Product6,
    name: "Bixton T5 Linear Lamp and Complete Fitting ",
    description:
      "A compact version of the T8 linear lamp, designed for indoor use with a sleek, modern appearance. Ideal for lighting passages, bathroom mirrors, and closets, it offers instant start, flicker-free performance, and is available in daylight, cool white, and warm white options.",
    cri: ">80",
    base: "G5",
    lifeHours: "10,000",
    beamAngle: "230°",
    categories: ["Home Lighting", "Commercial Lighting"],
    closetsSectionImage: ClosetsSectionImage_5,
    variants: [
      {
        voltage: "160-260V",
        power: "5W",
        lumen: "450",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "8W",
        lumen: "720",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "14W",
        lumen: "1260",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "18W",
        lumen: "1620",
        size: "",
      },
    ],
  },
  {
    id: 7,
    image: Product7,
    name: "Bixton LED Linear Lamps",
    description:
      "Designed to replace traditional fluorescent tube lights, the Bixton linear lamp range features glass diffusers in 2ft and 4ft T8 and T5 options. With single or double-ended connections, instant start, no flicker, and built-in gear, it installs easily in existing fixtures.",
    cri: ">80",
    base: "G13",
    lifeHours: "20,000",
    beamAngle: "230°",
    closetsSectionImage: ClosetsSectionImage_5,
    categories: [
      "Lamps",
      "Home Lighting",
      "Commercial Lighting",
      "Industrial Lighting",
    ],
    variants: [
      {
        voltage: "160-260V",
        power: "9W",
        lumen: "900",
        size: "600",
      },
      {
        voltage: "160-260V",
        power: "18W",
        lumen: "1800",
        size: "1200",
      },
      {
        voltage: "160-260V",
        power: "22W",
        lumen: "2100",
        size: "1200",
      },
    ],
  },

  {
    id: 8,
    image: Product8,
    name: "Bixton LED Spot Lights and Reflectors",
    description:
      "This range is designed for indoor lighting applications to highlight objects and key areas. It is ideal for ceilings in ballrooms and conference halls where rich illumination is needed. The compact lamp fits ceiling or exterior fittings, delivers vibrant colour effects, ensures energy efficiency, long life, and is available in 3000K warm white.",
    cri: ">80",
    base: "GU5.3/MR16/GU10",
    lifeHours: "10,000",
    beamAngle: "50°",
    closetsSectionImage: ClosetsSectionImage_1,
    categories: ["Home Lighting", "Commercial Lighting"],

    variants: [
      {
        voltage: "100-300V",
        power: "4W",
        lumen: "360",
        size: "",
      },
      {
        voltage: "100-300V",
        power: "5W",
        lumen: "450",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "6W",
        lumen: "540",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "7W",
        lumen: "630",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "5W",
        lumen: "450",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "7W",
        lumen: "630",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "7W",
        lumen: "720",
        size: "",
      },
    ],
  },
  {
    id: 9,
    image: Product9,
    name: "Filament Type LED",
    description:
      "Thisisadirect replacement for thetraditional lamps,designedtolook alike the incandescent, it’s a new generation filament LEDto give thatoriginal look.Idealforhomes& restaurants who are looking for brightness and the original ambience.",
    cri: ">80",
    base: "E27",
    lifeHours: "15,000",
    beamAngle: "320°",
    categories: ["Lamps", "Home Lighting"],
    closetsSectionImage: ClosetsSectionImage_2,
    variants: [
      {
        voltage: "220-240V",
        power: "6W Clear",
        lumen: "750",
        size: "",
      },
      {
        voltage: "220-240V",
        power: "8W Clear",
        lumen: "1150",
        size: "",
      },
      {
        voltage: "220-240V",
        power: "6W Golden",
        lumen: "660",
        size: "",
      },
      {
        voltage: "220-240V",
        power: "8W Golden",
        lumen: "850",
        size: "",
      },
    ],
  },
  {
    id: 10,
    image: Product10,
    name: "Bixton Filament LED Lamps",
    description:
      "Available in small and large globe sizes for functional lighting like floor lamps, table lamps, study lamps, and pendant lights. Fits any standard fixture, provides higher brightness than traditional bulbs, saves 80%+ energy, and comes in clear or amber glass.",
    cri: ">80",
    base: "",
    lifeHours: "15,000-20,000",
    beamAngle: "230°",
    categories: ["Lamps", "Home Lighting"],
    closetsSectionImage: ClosetsSectionImage_3,
    variants: [
      {
        voltage: "230V",
        power: "4W",
        lumen: "470",
        size: "G45",
      },
      {
        voltage: "230V",
        power: "4W",
        lumen: "470",
        size: "A60",
      },
      {
        voltage: "230V",
        power: "7W",
        lumen: "980",
        size: "A60",
      },
    ],
  },

  {
    id: 11,
    image: Product11,
    name: "Bixton CoB LED Downlights & Spot Lights",
    description:
      "A sleek, compact spotlight to highlight display areas, key objects, or wardrobes. Adjustable, available in surface or recessed mounting, black or white finishes, MR16/GU10 bases, and supports a wide voltage range of 85–265V.",
    cri: ">80",
    lifeHours: "20,000",
    beamAngle: "120°",

    categories: ["Commercial Lighting", "Home Lighting"],
    closetsSectionImage: ClosetsSectionImage_4,
    variants: [
      {
        voltage: "85-265V",
        power: "1W",
        lumen: "300",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "3W",
        lumen: "600",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "7W",
        lumen: "720",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "12W",
        lumen: "",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "18W",
        lumen: "",
        size: "",
      },
    ],
  },
  {
    id: 12,
    image: Product12,
    name: "Bixton LED Track Light",
    description:
      "Ideal for homes or showrooms highlighting special areas or objects, such as apparel, consumer durables, and jewellery displays. Adjustable track-mounted lights are available in black or white fittings, with track lengths up to 1.5 meters.",
    variants: [{ voltage: "", power: "", lumen: "", size: "" }],

    categories: ["Commercial Lighting", "Home Lighting"],
    closetsSectionImage: ClosetsSectionImage_6,
  },
  {
    id: 13,
    image: Product13,
    name: "Bixton Double Coloured Panel Light",
    description:
      "Creates a dynamic ambience with bright light when needed and a blue hue for special effects. Perfect for homes and restaurants, it enhances the atmosphere, adding style and mood to any environment or setting.",

    categories: [],
    closetsSectionImage: ClosetsSectionImage_7,
    variants: [
      {
        voltage: "85-265V",
        power: "6+3W",
        lumen: "420",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "12+4W",
        lumen: "540",
        size: "",
      },
      {
        voltage: "85-265V",
        power: "18+6W",
        lumen: "720",
        size: "",
      },
    ],
  },
  {
    id: 14,
    image: Product14,
    name: "Bixton Domestic Outdoor Lights",
    description:
      "A home lighting range for gardens and outdoor spaces, highlighting architecture and landscapes. Some fittings come without bulbs, which are sold separately. Made of diecast aluminum, these lights are durable and built to withstand tropical weather conditions.",
    variants: [{ voltage: "", power: "", lumen: "", size: "" }],
    categories: [],
    closetsSectionImage: ClosetsSectionImage_8,
  },

  {
    id: 15,
    image: Product15,
    name: "Bixton Flood Lights",
    description:
      "An ideal light fitting for outdoor security and illumination in factories, gardens, and outdoor objects. Made with a sturdy diecast aluminium housing and IP65 ingress protection to withstand tropical weather. An economical option for lighting large outdoor spaces, boards, and objects with low energy use and long lifespan.",
    cri: ">80",
    lifeHours: "20,000",
    beamAngle: "115°",
    categories: ["Industrial Lighting", "Security Lighting"],
    variants: [
      {
        voltage: "100-265V",
        power: "10W",
        lumen: "900",
        size: "",
      },
      {
        voltage: "100-265V",
        power: "20W",
        lumen: "1800",
        size: "",
      },
      {
        voltage: "100-265V",
        power: "30W",
        lumen: "2700",
        size: "",
      },
      {
        voltage: "100-265V",
        power: "50W",
        lumen: "4500",
        size: "",
      },
      {
        voltage: "100-265V",
        power: "100W",
        lumen: "9000",
        size: "",
      },
      {
        voltage: "100-265V",
        power: "150W",
        lumen: "13500",
        size: "",
      },
    ],
  },
  {
    id: 16,
    image: Product16,
    name: "Bixton LED Surface Mounted Diffuser Fittings",
    description:
      "Ideal for shops and small offices that require bright, uninterrupted lighting. Available in a range of wattages to suit different spaces. Its sleek design fits easily onto any ceiling without modifications and features a diamond-cut or milky white diffuser for a soft, soothing light.",
    cri: ">80",
    lifeHours: "15,000",
    categories: [],
    closetsSectionImage: ClosetsSectionImage_9,
    variants: [
      {
        voltage: "220-240V",
        power: "30W",
        lumen: "2700",
        size: "2ft",
      },
      {
        voltage: "220-240V",
        power: "54W",
        lumen: "4800",
        size: "4ft",
      },
      {
        voltage: "220-240V",
        power: "72W",
        lumen: "6400",
        size: "4ft",
      },
      {
        voltage: "220-240V",
        power: "100W",
        lumen: "9000",
        size: "4ft",
      },
    ],
  },
  {
    id: 17,
    image: Product17,
    name: "Bixton Recessed Panel Lights",
    description:
      "An elegant ceiling-grid light that delivers high light output without affecting aesthetics. Made with high-quality PMMA diffusers for uniform light distribution and a 2.5kV surge protector. Back-lit with an external driver, it fits standard 595×595 mm grids and is available in warm white, daylight, and cool white with a white frame.",
    cri: ">80",
    lifeHours: "20,000-25,000",
    beamAngle: "120°",

    categories: ["Commercial Lighting"],
    closetsSectionImage: ClosetsSectionImage_10,
    variants: [
      {
        voltage: "100-300V",
        power: "48W",
        lumen: "6000",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "150W",
        lumen: "18000",
        size: "",
      },
      {
        voltage: "100-260V",
        power: "200W",
        lumen: "24000",
        size: "",
      },
    ],
  },
  {
    id: 18,
    image: Product18,
    name: "Bixton LED High Bay Lights",
    description:
      "An ideal solution for large industrial work areas, designed as a direct replacement for conventional high/low bay luminaires. Built with a 10kV surge protector and mounting ring, it can be surface-mounted or suspended. Its optics provide uniform, well-distributed light, with IP65 protection for demanding environments.",
    cri: ">80",
    lifeHours: "20,000",
    beamAngle: "90°",

    categories: ["Industrial Lighting"],
    closetsSectionImage: ClosetsSectionImage_11,
    variants: [
      {
        voltage: "110-265V",
        power: "100W",
        lumen: "12000",
        size: "",
      },
      {
        voltage: "160-260V",
        power: "150W",
        lumen: "18000",
        size: "",
      },
      {
        voltage: "100-260V",
        power: "200W",
        lumen: "24000",
        size: "",
      },
    ],
  },

  {
    id: 19,
    image: Product19,
    name: "Bixton LED Street Lights",
    description:
      "Made of sturdy die-cast aluminium to withstand tropical weather, this fitting is an ideal replacement for conventional streetlights. Best mounted on a 5-meter pole for optimal light distribution, it offers an economical and efficient lighting solution for all types of roads.",
    cri: ">80",
    lifeHours: "30,000",
    beamAngle: "115°",
    categories: ["Street Lighting", "Security Lighting"],
    closetsSectionImage: ClosetsSectionImage_12,
    variants: [
      { voltage: "100-265V", power: "50W", lumen: "6000", size: "" },
      { voltage: "100-265V", power: "100W", lumen: "12000", size: "" },
      { voltage: "100-265V", power: "150W", lumen: "18000", size: "" },
      { voltage: "100-265V", power: "200W", lumen: "24000", size: "" },
    ],
  },
  {
    id: 20,
    image: Product20,
    name: "Bixton LED Solar Street Lights",
    description:
      "Designed to light streets and perimeter areas with zero electricity use, this fitting features an in-built solar panel that charges in direct sunlight. Equipped with a motion sensor, it can operate up to 8 hours when fully charged and allows time-based programming. Performance depends on charging levels and requires unobstructed sunlight for optimal use.",
    lifeHours: "20,000",
    categories: ["Street Lighting", "Security Lighting"],
    closetsSectionImage: ClosetsSectionImage_13,
    variants: [
      { voltage: "", power: "50W", lumen: "3000", size: "" },
      { voltage: "", power: "100W", lumen: "6000", size: "" },
      { voltage: "", power: "150W", lumen: "9000", size: "" },
      { voltage: "", power: "200W", lumen: "12000", size: "" },
    ],
  },
  {
    id: 21,
    image: Product21,
    name: "Bixton Ventilating & Exhaust Fans",
    description:
      "Expels stale/hot air, smoke, fumes from industrial floors also helps to draw out moisture and odors. Ideal for industrial applications, made of steel with powder coated paint for durability. ",
    variants: [{ voltage: "", power: "", lumen: "", size: "" }],
    categories: [],
  },

  {
    id: 22,
    image: Product22,
    name: "Bixton Other Light Fixtures & Accessories",
    description:
      "Made of sturdy die-cast aluminium to withstand tropical weather, this fitting is an ideal replacement for conventional streetlights. Best mounted on a 5-meter pole for optimal light distribution, it provides an economical and efficient lighting solution for all types of roads.",
    variants: [{ voltage: "", power: "", lumen: "", size: "" }],
    categories: [],
  },
];